import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const companiesAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = companiesAdapter.getInitialState()

export const companiesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompanies: builder.query({
            query: () => ({
                url: '/api/companies',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedCompanies = responseData.map(company => {
                    company.id = company._id
                    return company
                });
                return companiesAdapter.setAll(initialState, loadedCompanies)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Company', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Company', id }))
                    ]
                } else return [{ type: 'Company', id: 'LIST' }]
            }
        }),
        addNewCompany: builder.mutation({
            query: initialCompany => ({
                url: '/api/companies',
                method: 'POST',
                body: {
                    ...initialCompany,
                }
            }),
            invalidatesTags: [
                { type: 'Company', id: "LIST" }
            ]
        }),
        updateCompany: builder.mutation({
            query: initialCompany => ({
                url: '/api/companies',
                method: 'PATCH',
                body: {
                    ...initialCompany,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Company', id: arg.id }
            ]
        }),
        deleteCompany: builder.mutation({
            query: ({ id }) => ({
                url: `/api/companies`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Company', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetCompaniesQuery,
    useAddNewCompanyMutation,
    useUpdateCompanyMutation,
    useDeleteCompanyMutation,
} = companiesApiSlice

// returns the query result object
export const selectCompaniesResult = companiesApiSlice.endpoints.getCompanies.select()

// creates memoized selector
const selectCompaniesData = createSelector(
    selectCompaniesResult,
    companiesResult => companiesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllCompanies,
    selectById: selectCompanyById,
    selectIds: selectCompanyIds
    // Pass in a selector that returns the companies slice of state
} = companiesAdapter.getSelectors(state => selectCompaniesData(state) ?? initialState)